import Vue from "vue";
import VueI18n from "vue-i18n";
// 全局挂载
Vue.use(VueI18n);

export const i18n = new VueI18n({
    // 从localStorage中获取 默认英文
    locale: localStorage.getItem("locale") || "cn",
    messages: {
        // 中文语言包
        cn: require("./lan/zh"),
        // 英文语言包
        en: require("./lan/en"),
        // 日语语言包
        jpn: require("./lan/jpn")
    }
});

export default i18n;
